import { Box, Typography } from '@mui/material'
import SideButtonContainer from '../Cards/helpers/SideButtonContainerWithModal'

const BtnWithDropDownList = ({
  onClick,
  children,
  icon,
  customBtnIcon,
  title,
  customStyle,
}) => (
  <Box sx={[styles.root, customStyle && customStyle]}>
    <Box onClick={onClick} sx={styles.iconWithText}>
      {icon }
      <Typography>{ title }</Typography>
    </Box>

    <SideButtonContainer
      customStyle={styles.sideButtonCustomStyle}
      customBtnIcon={customBtnIcon}
    >
      {children}
    </SideButtonContainer>
  </Box>
)

const styles = {
  root: {
    backgroundColor: '#29CC8B',
    display: 'flex',
    alignItems: 'center',
    color: 'white',
    pl: '10px',
    fontSize: '14px',
    gap: '13px',
    borderRadius: '10px',
    cursor: 'pointer',
  },
  iconWithText: {
    width: { xs: '100%', sm: 'unset' },
    display: 'flex',
    alignItems: 'center',
    justifyContent: { xs: 'center', sm: 'unset' },
    gap: '13px',
    fontWeight: 'bold',
  },
  sideButtonCustomStyle: {
    minWidth: { xs: '50px', sm: '40px' },
    backgroundColor: '#29CC8B',
    border: 'none',
    marginRight: '-20px',
    borderLeft: ' 1px solid white',
    borderRadius: '0px',
    borderTopRightRadius: '10px',
    borderBottomRightRadius: '10px',
    '& svg': {
      color: 'white',
    },

  },
}

export default BtnWithDropDownList
